import { useState, useEffect, useCallback } from "react";
import { useAuth } from "../contexts/AuthContext";
import CompanyChartTab from "./CompanyChartTab";
import TiersCodesTab from "./TiersCodesTab";

const S = {
  card: { background: "#ffffff", border: "1px solid #e5e7eb", borderRadius: 12, padding: 20 },
  input: { background: "#f9fafb", border: "1px solid #d1d5db", borderRadius: 8, color: "#111827", padding: "8px 12px", fontSize: 13, width: "100%" },
  btn: { padding: "8px 16px", borderRadius: 8, border: "none", cursor: "pointer", fontSize: 13, fontWeight: 600 },
};

// PCG 2025 — classes 1 à 8
const PCG_CLASSES = [
  { num: "1", name: "Comptes de capitaux", color: "#185fa5", accounts: [
    { num: "101000", name: "Capital social", nature: "P" },
    { num: "104000", name: "Primes liées au capital social", nature: "P" },
    { num: "106100", name: "Réserve légale", nature: "P" },
    { num: "110000", name: "Report à nouveau (solde créditeur)", nature: "P" },
    { num: "119000", name: "Report à nouveau (solde débiteur)", nature: "A" },
    { num: "120000", name: "Résultat de l'exercice (bénéfice)", nature: "P" },
    { num: "129000", name: "Résultat de l'exercice (perte)", nature: "A" },
    { num: "164000", name: "Emprunts auprès des établissements de crédit", nature: "P" },
    { num: "166000", name: "Participation des salariés aux résultats", nature: "P" },
  ]},
  { num: "2", name: "Comptes d'immobilisations", color: "#8b5cf6", accounts: [
    { num: "205000", name: "Concessions, brevets, licences, logiciels", nature: "A" },
    { num: "211000", name: "Terrains", nature: "A" },
    { num: "213000", name: "Constructions — Bâtiments", nature: "A" },
    { num: "215000", name: "Installations techniques, matériel et outillage", nature: "A" },
    { num: "218200", name: "Matériel de transport", nature: "A" },
    { num: "218300", name: "Matériel de bureau et informatique", nature: "A" },
    { num: "218400", name: "Mobilier", nature: "A" },
    { num: "281800", name: "Amortissements — Autres immobilisations corp.", nature: "P" },
  ]},
  { num: "3", name: "Comptes de stocks", color: "#f59e0b", accounts: [
    { num: "310000", name: "Matières premières et approvisionnements", nature: "A" },
    { num: "355000", name: "Produits finis", nature: "A" },
    { num: "370000", name: "Stocks de marchandises", nature: "A" },
  ]},
  { num: "4", name: "Comptes de tiers", color: "#ef4444", accounts: [
    { num: "401000", name: "Fournisseurs", nature: "P" },
    { num: "404000", name: "Fournisseurs d'immobilisations", nature: "P" },
    { num: "408000", name: "Fournisseurs — Factures non parvenues", nature: "P" },
    { num: "411000", name: "Clients", nature: "A" },
    { num: "416000", name: "Clients douteux ou litigieux", nature: "A" },
    { num: "418000", name: "Clients — Produits à recevoir", nature: "A" },
    { num: "421000", name: "Personnel — Rémunérations dues", nature: "P" },
    { num: "431000", name: "Sécurité sociale", nature: "P" },
    { num: "437000", name: "Autres organismes sociaux", nature: "P" },
    { num: "444000", name: "État — Impôt sur les bénéfices", nature: "P" },
    { num: "445510", name: "TVA à décaisser", nature: "P" },
    { num: "445660", name: "TVA déductible sur ABS", nature: "A" },
    { num: "455000", name: "Associés — Comptes courants", nature: "P" },
  ]},
  { num: "5", name: "Comptes financiers", color: "#1a9e72", accounts: [
    { num: "512000", name: "Banque — Compte courant principal", nature: "A" },
    { num: "512100", name: "Banque BNP Paribas Pro", nature: "A" },
    { num: "512200", name: "Banque — Compte secondaire", nature: "A" },
    { num: "516000", name: "Valeurs mobilières de placement", nature: "A" },
    { num: "530000", name: "Caisse", nature: "A" },
  ]},
  { num: "6", name: "Comptes de charges", color: "#e24b4a", accounts: [
    { num: "601000", name: "Achats de matières premières", nature: "C" },
    { num: "606000", name: "Achats non stockés de matières et fournitures", nature: "C" },
    { num: "607000", name: "Achats de marchandises", nature: "C" },
    { num: "611000", name: "Sous-traitance générale", nature: "C" },
    { num: "615000", name: "Entretien et réparations", nature: "C" },
    { num: "616000", name: "Primes d'assurances", nature: "C" },
    { num: "621000", name: "Personnel extérieur à l'entreprise", nature: "C" },
    { num: "622600", name: "Honoraires", nature: "C" },
    { num: "623000", name: "Publicité, publications, relations publiques", nature: "C" },
    { num: "625100", name: "Voyages et déplacements", nature: "C" },
    { num: "626000", name: "Frais postaux et de télécommunications", nature: "C" },
    { num: "641000", name: "Rémunérations du personnel", nature: "C" },
    { num: "645000", name: "Charges de sécurité sociale et prévoyance", nature: "C" },
    { num: "681100", name: "Dotations aux amortissements — immos corp.", nature: "C" },
    { num: "695000", name: "Impôts sur les bénéfices", nature: "C" },
  ]},
  { num: "7", name: "Comptes de produits", color: "#1a9e72", accounts: [
    { num: "701000", name: "Ventes de produits finis", nature: "P" },
    { num: "706000", name: "Prestations de services", nature: "P" },
    { num: "707000", name: "Ventes de marchandises", nature: "P" },
    { num: "708500", name: "Ports et frais accessoires facturés", nature: "P" },
    { num: "709000", name: "Rabais, remises et ristournes accordés", nature: "P" },
    { num: "756000", name: "Produits financiers", nature: "P" },
    { num: "775000", name: "Produits des cessions d'éléments d'actif", nature: "P" },
  ]},
  { num: "8", name: "Comptes spéciaux", color: "#4b5563", accounts: [
    { num: "801000", name: "Engagements donnés (cautions, avals)", nature: "—" },
    { num: "802000", name: "Engagements reçus", nature: "—" },
  ]},
];

function fmt(n) { return (n || 0).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }

export default function PlanComptable({ currentCompanyId, currentSociete }) {
  const { getToken } = useAuth();
  const [tab, setTab] = useState("arborescence");
  const [search, setSearch] = useState("");
  const [expanded, setExpanded] = useState(new Set(["4", "5", "7"]));
  const [accountBalances, setAccountBalances] = useState({});
  const [entries, setEntries] = useState([]);
  const [entriesLoading, setEntriesLoading] = useState(false);
  const [filterClass, setFilterClass] = useState("");
  const [filterPage, setFilterPage] = useState(1);

  const call = useCallback(async (path) => {
    const res = await fetch(path, { headers: { Authorization: "Bearer " + getToken() } });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  }, [getToken]);

  // Load account balances from bank-accounts + accounting dashboard
  useEffect(() => {
    if (!currentCompanyId) return;
    call(`/api/bank-accounts?company_id=${currentCompanyId}`).then(d => {
      const balances = {};
      (Array.isArray(d) ? d : []).forEach(a => {
        const key = a.account_number?.slice(0, 6) || "512000";
        balances[key] = (balances[key] || 0) + parseFloat(a.balance || a.current_balance || 0);
      });
      setAccountBalances(balances);
    }).catch(() => {});
  }, [currentCompanyId, call]);

  const loadEntries = useCallback(async () => {
    if (!currentCompanyId) return;
    setEntriesLoading(true);
    try {
      const d = await call(`/api/accounting/entries?company_id=${currentCompanyId}&limit=200`);
      setEntries(Array.isArray(d) ? d : (d?.entries || []));
    } catch { setEntries([]); } finally { setEntriesLoading(false); }
  }, [currentCompanyId, call]);

  useEffect(() => { if (tab === "journal") loadEntries(); }, [tab, loadEntries]);

  const toggleClass = (num) => {
    setExpanded(prev => {
      const next = new Set(prev);
      if (next.has(num)) next.delete(num); else next.add(num);
      return next;
    });
  };

  const matchesSearch = (acc) => {
    if (!search) return true;
    const q = search.toLowerCase();
    return acc.num.includes(q) || acc.name.toLowerCase().includes(q);
  };

  const filteredClasses = PCG_CLASSES.filter(cls => {
    if (search) return cls.accounts.some(matchesSearch);
    return true;
  });

  const natureLabel = { A: "Débit", P: "Crédit", C: "Débit (charge)", "—": "Neutre" };
  const natureColor = { A: "#185fa5", P: "#1a9e72", C: "#ef4444", "—": "#4b5563" };

  const totalByClass = (num) => {
    const cls = PCG_CLASSES.find(c => c.num === num);
    if (!cls) return 0;
    return cls.accounts.reduce((s, a) => s + (accountBalances[a.num.slice(0, 6)] || 0), 0);
  };

  const pagedEntries = entries.filter(e => !filterClass || e.account?.startsWith(filterClass)).slice((filterPage - 1) * 20, filterPage * 20);
  const totalEntryPages = Math.ceil(entries.filter(e => !filterClass || e.account?.startsWith(filterClass)).length / 20);

  const TABS = [
    { id: "societe",      label: "🏢 Plan de la société" },
    { id: "tiers",        label: "👥 Codes tiers" },
    { id: "arborescence", label: "🗂️ Arborescence PCG" },
    { id: "journal",      label: "📋 Journal des écritures" },
    { id: "balances",     label: "⚖️ Balance" },
    { id: "lettrage",     label: "✉️ Lettrage" },
  ];

  return (
    <div style={{ padding: "0 0 40px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 24 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800, color: "#111827" }}>📋 Plan Comptable Général</h2>
          <div style={{ fontSize: 12, color: "#4b5563", marginTop: 2 }}>{currentSociete} — PCG 2025</div>
        </div>
        <button onClick={() => window.print()} style={{ ...S.btn, background: "#f9fafb", color: "#4b5563" }}>🖨️ Imprimer</button>
      </div>

      <div style={{ display: "flex", gap: 4, marginBottom: 24, borderBottom: "1px solid #e5e7eb" }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{ ...S.btn, background: "transparent", color: tab === t.id ? "#1a9e72" : "#4b5563", borderBottom: `2px solid ${tab === t.id ? "#1a9e72" : "transparent"}`, borderRadius: 0, padding: "8px 16px 10px" }}>{t.label}</button>
        ))}
      </div>

      {tab === "societe" && <CompanyChartTab companyId={currentCompanyId} />}
      {tab === "tiers" && <TiersCodesTab />}

      {/* ── Arborescence ── */}
      {tab === "arborescence" && (
        <div>
          <div style={{ marginBottom: 16 }}>
            <input placeholder="🔍 Rechercher un compte (numéro ou libellé)…" value={search} onChange={e => setSearch(e.target.value)} style={{ ...S.input, maxWidth: 380 }} />
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {filteredClasses.map(cls => {
              const isOpen = expanded.has(cls.num);
              const visibleAccounts = cls.accounts.filter(matchesSearch);
              return (
                <div key={cls.num} style={S.card}>
                  <div onClick={() => toggleClass(cls.num)} style={{ display: "flex", alignItems: "center", gap: 12, cursor: "pointer", marginBottom: isOpen && visibleAccounts.length > 0 ? 16 : 0 }}>
                    <div style={{ width: 36, height: 36, borderRadius: 8, background: cls.color + "22", border: `1px solid ${cls.color}44`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                      <span style={{ fontSize: 16, fontWeight: 800, color: cls.color }}>{cls.num}</span>
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ color: "#111827", fontWeight: 700, fontSize: 14 }}>Classe {cls.num} — {cls.name}</div>
                      <div style={{ color: "#4b5563", fontSize: 11 }}>{cls.accounts.length} comptes</div>
                    </div>
                    <span style={{ color: "#4b5563", fontSize: 14, fontWeight: 600 }}>{isOpen ? "▲" : "▼"}</span>
                  </div>

                  {isOpen && visibleAccounts.length > 0 && (
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                      <thead>
                        <tr style={{ borderBottom: "1px solid #e5e7eb" }}>
                          {["N° compte", "Intitulé", "Nature", "Solde"].map(h => (
                            <th key={h} style={{ padding: "6px 10px", textAlign: "left", color: "#4b5563", fontWeight: 600, fontSize: 10, textTransform: "uppercase" }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {visibleAccounts.map(a => {
                          const balance = accountBalances[a.num.slice(0, 6)] || null;
                          return (
                            <tr key={a.num} style={{ borderBottom: "1px solid #f3f4f6" }}>
                              <td style={{ padding: "7px 10px", fontFamily: "monospace", color: cls.color, fontWeight: 700, fontSize: 12 }}>{a.num}</td>
                              <td style={{ padding: "7px 10px", color: "#111827" }}>{a.name}</td>
                              <td style={{ padding: "7px 10px" }}>
                                <span style={{ fontSize: 10, padding: "2px 6px", borderRadius: 20, background: (natureColor[a.nature] || "#4b5563") + "22", color: natureColor[a.nature] || "#4b5563", fontWeight: 700 }}>
                                  {natureLabel[a.nature] || a.nature}
                                </span>
                              </td>
                              <td style={{ padding: "7px 10px", color: balance !== null ? (balance >= 0 ? "#1a9e72" : "#ef4444") : "#4b5563", fontWeight: balance !== null ? 700 : 400 }}>
                                {balance !== null ? fmt(balance) + " €" : "—"}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ── Journal ── */}
      {tab === "journal" && (
        <div>
          <div style={{ display: "flex", gap: 12, marginBottom: 16, flexWrap: "wrap", alignItems: "flex-end" }}>
            <div>
              <label style={{ display: "block", color: "#4b5563", fontSize: 11, marginBottom: 4 }}>Filtrer par classe</label>
              <select value={filterClass} onChange={e => { setFilterClass(e.target.value); setFilterPage(1); }} style={{ ...S.input, width: 160 }}>
                <option value="">Toutes les classes</option>
                {PCG_CLASSES.map(c => <option key={c.num} value={c.num}>Classe {c.num}</option>)}
              </select>
            </div>
            <button onClick={loadEntries} style={{ ...S.btn, background: "#185fa5", color: "#fff" }}>🔄 Actualiser</button>
          </div>

          {entriesLoading ? <div style={{ textAlign: "center", padding: 40, color: "#4b5563" }}>Chargement…</div> : (
            <div style={S.card}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                <thead>
                  <tr style={{ borderBottom: "1px solid #e5e7eb" }}>
                    {["Date", "N° compte", "Libellé", "Débit", "Crédit", "Référence"].map(h => (
                      <th key={h} style={{ padding: "8px 12px", textAlign: "left", color: "#4b5563", fontWeight: 600, fontSize: 10, textTransform: "uppercase" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {pagedEntries.map((e, i) => (
                    <tr key={i} style={{ borderBottom: "1px solid #f3f4f6" }}>
                      <td style={{ padding: "7px 12px", color: "#4b5563" }}>{(e.date || e.created_at || "").slice(0, 10)}</td>
                      <td style={{ padding: "7px 12px", fontFamily: "monospace", color: "#185fa5", fontWeight: 700 }}>{e.account || e.account_number || "—"}</td>
                      <td style={{ padding: "7px 12px", color: "#111827" }}>{e.label || e.description || "—"}</td>
                      <td style={{ padding: "7px 12px", color: "#185fa5", fontWeight: 700 }}>{e.debit > 0 ? fmt(e.debit) + " €" : "—"}</td>
                      <td style={{ padding: "7px 12px", color: "#1a9e72", fontWeight: 700 }}>{e.credit > 0 ? fmt(e.credit) + " €" : "—"}</td>
                      <td style={{ padding: "7px 12px", color: "#4b5563", fontSize: 11 }}>{e.reference || e.journal || "—"}</td>
                    </tr>
                  ))}
                  {pagedEntries.length === 0 && <tr><td colSpan={6} style={{ padding: 30, textAlign: "center", color: "#4b5563" }}>Aucune écriture comptable trouvée</td></tr>}
                </tbody>
              </table>
              {totalEntryPages > 1 && (
                <div style={{ display: "flex", gap: 8, justifyContent: "center", marginTop: 16 }}>
                  <button disabled={filterPage === 1} onClick={() => setFilterPage(p => p - 1)} style={{ ...S.btn, background: "#f9fafb", color: "#4b5563", opacity: filterPage === 1 ? 0.4 : 1 }}>← Préc.</button>
                  <span style={{ color: "#4b5563", fontSize: 13, lineHeight: "34px" }}>Page {filterPage} / {totalEntryPages}</span>
                  <button disabled={filterPage === totalEntryPages} onClick={() => setFilterPage(p => p + 1)} style={{ ...S.btn, background: "#f9fafb", color: "#4b5563", opacity: filterPage === totalEntryPages ? 0.4 : 1 }}>Suiv. →</button>
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {/* ── Balance ── */}
      {tab === "balances" && (
        <div style={S.card}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#111827", marginBottom: 4 }}>Balance des comptes — {currentSociete}</div>
          <div style={{ fontSize: 12, color: "#4b5563", marginBottom: 20 }}>Soldes des comptes principaux basés sur les données disponibles.</div>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr style={{ borderBottom: "2px solid #e5e7eb", background: "#f9fafb" }}>
                {["Classe", "Intitulé", "Comptes", "Solde total", "Nature"].map(h => (
                  <th key={h} style={{ padding: "10px 14px", textAlign: "left", color: "#4b5563", fontWeight: 700, fontSize: 11, textTransform: "uppercase" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {PCG_CLASSES.map(cls => {
                const total = totalByClass(cls.num);
                return (
                  <tr key={cls.num} style={{ borderBottom: "1px solid #f3f4f6" }}>
                    <td style={{ padding: "10px 14px" }}>
                      <span style={{ fontSize: 13, fontWeight: 800, color: cls.color }}>Classe {cls.num}</span>
                    </td>
                    <td style={{ padding: "10px 14px", color: "#111827", fontWeight: 600 }}>{cls.name}</td>
                    <td style={{ padding: "10px 14px", color: "#4b5563" }}>{cls.accounts.length}</td>
                    <td style={{ padding: "10px 14px", fontWeight: 800, color: total !== 0 ? (total > 0 ? "#1a9e72" : "#ef4444") : "#4b5563", fontSize: 14 }}>
                      {total !== 0 ? fmt(total) + " €" : "—"}
                    </td>
                    <td style={{ padding: "10px 14px" }}>
                      <span style={{ fontSize: 10, padding: "2px 8px", borderRadius: 20, background: cls.color + "22", color: cls.color, fontWeight: 700 }}>
                        {["1","2","3","5"].includes(cls.num) ? "Bilan" : ["4"].includes(cls.num) ? "Tiers" : "Résultat"}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* ── Lettrage ── */}
      {tab === "lettrage" && (
        <div>
          <div style={{ background: "rgba(24,95,165,0.1)", border: "1px solid rgba(24,95,165,0.3)", borderRadius: 10, padding: 14, marginBottom: 20, fontSize: 13, color: "#60a5fa" }}>
            ℹ️ Le lettrage consiste à rapprocher les écritures de débit et de crédit d'un même compte (411 Clients, 401 Fournisseurs) pour identifier les mouvements soldés.
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
            {[
              { num: "411000", name: "Clients", color: "#185fa5" },
              { num: "401000", name: "Fournisseurs", color: "#8b5cf6" },
            ].map(acc => (
              <div key={acc.num} style={S.card}>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#111827", marginBottom: 4 }}>{acc.num} — {acc.name}</div>
                <div style={{ color: "#4b5563", fontSize: 12, marginBottom: 16 }}>Écritures en attente de lettrage</div>
                <div style={{ textAlign: "center", padding: 30, background: "#f9fafb", borderRadius: 8 }}>
                  <div style={{ color: "#4b5563", fontSize: 13 }}>Connectez votre comptabilité pour activer le lettrage automatique.</div>
                  <button style={{ marginTop: 12, ...S.btn, background: acc.color + "22", color: acc.color, fontSize: 12 }}>🔗 Activer le lettrage</button>
                </div>
              </div>
            ))}
          </div>
          <div style={{ ...S.card, marginTop: 20 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: "#111827", marginBottom: 12 }}>Export comptable</div>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              <button style={{ ...S.btn, background: "rgba(26,158,114,0.2)", color: "#1a9e72" }}>⬇️ Export FEC (TXT)</button>
              <button style={{ ...S.btn, background: "rgba(24,95,165,0.2)", color: "#60a5fa" }}>⬇️ Export CSV Balance</button>
              <button style={{ ...S.btn, background: "rgba(83,74,183,0.2)", color: "#a78bfa" }}>⬇️ Liasse fiscale PDF</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
